export default __webpack_public_path__ + "static/media/3.0c00d034.jpeg";